export default __webpack_public_path__ + "static/media/2-1.518b21a6.png";